import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

@Injectable()
export class FilterModelsService {
    _filterViewStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);
    _showOnlyFavorites: BehaviorSubject<boolean> = new BehaviorSubject(false);
    _bedRooms: BehaviorSubject<string> = new BehaviorSubject('1,2,3,4');
    _squareFootage: BehaviorSubject<any> = new BehaviorSubject({
        min: 0,
        max: Infinity
    });

    showFilter() {
        this._filterViewStatus.next(true);
    }

    hideFilter() {
        this._filterViewStatus.next(false);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/filter-models.service.ts